export const FRANCHISE_CARE_ROLE = 'franchiseCare'
export const OPENING_SERVICES_ROLE = 'openingServices'
export const DISTRIBUTION_USER_ROLE = 'distributionUser'
export const AREA_DIRECTOR_ROLE = 'areaDirector'
export const HOTEL_CONTACT_ROLE = 'hotelContact'
export const HOTEL_CONTACT_ROLE_ALT = 'propelHotelContact'
export const REVENUE_MANAGER_ROLE = 'revenueManager'
export const SKYTOUCH_USERS_ROLE = 'skyTouchUsers'
export const READ_ONLY_PROPEL_ROLE = 'propelReadOnly'
export const FULL_ACCESS_PROPEL_ROLE = 'propelFullAccess'

export const ADMIN_ROLES = [FRANCHISE_CARE_ROLE, OPENING_SERVICES_ROLE, DISTRIBUTION_USER_ROLE]
export const READ_ONLY_ROLES = [AREA_DIRECTOR_ROLE, REVENUE_MANAGER_ROLE, SKYTOUCH_USERS_ROLE]
export const HOTEL_CONTACT_ROLES = [HOTEL_CONTACT_ROLE, HOTEL_CONTACT_ROLE_ALT]